import {API} from 'api';

const getQuestions = async (limit?: number) => {
  const url = '/v1/questions' + (limit ? `?limit=${limit}` : '');
  return (await API.get(url)) as Question[];
};

const getQuestionPreview = async (slug: string) => {
  return (await API.get(`/v1/questions/preview/${slug}`)) as QuestionPreview;
};

const getQuestionDetail = async (slug: string) => {
  const response = await API.get(`/v1/questions/detail/${slug}`);
  if (response.error) return {error: response.error as string, question: null};

  const question = response as Question;
  question.contentType = 'question';

  return {question, error: ''};
};

const getPromotedQuestions = async () => {
  const questions = (await API.get(`/v1/questions/promoted`)) as Question[];
  return questions.map(
    (question) =>
      ({
        ...question,
        contentType: 'question',
      } as Question),
  );
};

const getAnswer = async (slug: string) => {
  const response = await API.get(`/v1/questions/answer/${slug}`);
  return (response.answer || '') as string;
};

const getQuestionTags = async () => {
  return (await API.get('/v1/questions/tags')) as QuestionTag[];
};

// TODO: This is deprecated, don't use anymore.
const getQuestionTypes = async () => {
  return (await API.get('/v1/questions/types')) as QuestionType[];
};

const getHintsAndGotchas = async (slug: string) => {
  const response = await API.get(`/v1/questions/hints/${slug}`);
  return {
    hints: (response.hints?.map((hint: any) => hint.value) || []) as string[],
    gotchas: (response.gotchas?.map((gotcha: any) => gotcha.value) || []) as string[],
  };
};

const markCompleted = async (slug: string, is_completed: boolean) => {
  await API.post(`/v1/questions/prefs/${slug}`, {is_completed});
};

const saveQuestion = async (slug: string, is_saved: boolean) => {
  await API.post(`/v1/questions/prefs/${slug}`, {is_saved});
};

const getQuestionStats = async (slug: string, statsType: string) => {
  return (await API.get(`/v1/questions/stats/${slug}?type=${statsType}`)) as QuestionStats;
};

const submitFeedback = async (
  uuid: string,
  {
    companyName,
    companyId,
    positionTitleName,
    positionTitleId,
    askedDate,
  }: {
    companyName: string;
    companyId?: number;
    positionTitleName: string;
    positionTitleId?: number;
    askedDate: number;
  },
) => {
  await API.post(`/v1/questions/feedback/${uuid}`, {
    uuid,
    company: companyName,
    company_id: companyId,
    position: positionTitleName,
    position_title_id: positionTitleId,
    asked_date: askedDate,
  });
};

const getCategories = async () => {
  return (await API.get(`/v1/questions/categories`)) as QuestionCategory[];
};

const getAdminQuestions = async () => {
  return (await API.get('/v1/admin/questions')) as AdminQuestion[];
};

const deleteAdminQuestion = async (id: number) => {
  return (await API.delete(`/v1/admin/questions/${id}`)) as AdminQuestion;
};

const getAdminQuestion = async (slug: string) => {
  return (await API.get(`/v1/admin/questions/${slug}`)) as AdminQuestion;
};

const saveAdminQuestion = async (question: AdminQuestion) => {
  let apiMethod = API.post;
  let url = '/v1/admin/questions';
  if (question.id) {
    apiMethod = API.put;
    url += `/${question.id}`;
  }
  const response = await apiMethod(url, question);
  if (response.error) return {question: null, error: response.error as string};
  return {question: response as AdminQuestion, error: ''};
};

const adminValidateTestCases = async (request: AdminCodeRunRequest) => {
  return (await API.post('/v1/admin/questions/validate-test-cases', request)) as CodeRunResponse;
};

export const QuestionsAPI = {
  getQuestions,
  getQuestionDetail,
  getPromotedQuestions,
  getAnswer,
  getHintsAndGotchas,
  markCompleted,
  saveQuestion,
  submitFeedback,
  getCategories,
  getQuestionTags,
  getQuestionPreview,
  getQuestionTypes,
  getAdminQuestions,
  getAdminQuestion,
  saveAdminQuestion,
  adminValidateTestCases,
  getQuestionStats,
  deleteAdminQuestion,
};
